import React from 'react';
import { Stack, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { RouteMap } from '@/routes/Routes';
import { useExtensionManager } from '@/hooks/useExtensionManager';
import { useAuthProtection } from '@/features/auth/useAuthProtection';
import NewNoteModal from '@/components/CustomModal/NewNoteModal';
import TrialWelcomeCta from '@/components/TrialWelcome/TrialWelcomeCta';
import TrialWelcomeComparisonTable from '@/components/TrialWelcome/TrialWelcomeComparisonTable';
import TrialWelcomeHeader from '@/components/TrialWelcome/TrialWelcomeHeader';
import { useTrialWelcomeData } from '@/components/TrialWelcome/useTrialWelcomeData';

const TrialWelcome: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isLargeDesktop = useMediaQuery(theme.breakpoints.up(1280));
  const { comparisonData, loading } = useTrialWelcomeData();
  const { isModalOpen, checkExtensionInstalled, onModalConfirm, setIsModalOpen } = useExtensionManager();
  const { canCreateNote } = useAuthProtection();

  const trialDays = comparisonData?.trialDays ?? 14;

  return (
    <Stack
      spacing={{ xs: 4, md: 3 }}
      alignItems="center"
      sx={{
        py: { xs: 1, sm: 1.5, md: 2 },
        px: { xs: 2, sm: 3, md: 0 },
        maxWidth: 1400,
        margin: '0 auto',
        width: '100%',
      }}
    >
      <TrialWelcomeHeader
        isLargeDesktop={isLargeDesktop}
        canCreateNote={canCreateNote}
        trialDays={trialDays}
        onCreateNote={checkExtensionInstalled}
        onUpgrade={() => navigate(`${RouteMap.PLAN}#${RouteMap.PLAN_ANCHOR}`)}
      />

      <TrialWelcomeComparisonTable comparisonData={comparisonData} loading={loading} />

      <TrialWelcomeCta />

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      {/* New Note Modal */}
      <NewNoteModal open={isModalOpen} handleClose={() => setIsModalOpen(false)} onConfirm={onModalConfirm} />
    </Stack>
  );
};

export default TrialWelcome;
